import React, { useState } from "react";
import { Button, Tooltip, Skeleton, Form, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import {
  HomePageHeader,
  HeaderLeftItemsWrapper,
  HeaderRightItemsWrapper,
  HeaderRightItem,
} from "../../Common/UIElements";
import PMSSelect from "../../Common/DataAttachedElements/PMSSelect";
import AddPMSReport from "../../../views/Pms/AddPMSReport/AddPMSReport";
import BulkPMSReportCreation from "../../BulkCreation/BulkPMSReportCreation/BulkPMSReportCreation";

const ViewReportListHeader = ({
  getPMSReportData,
  refetchReports,
  reportLoading,
  pmsId,
  dromoResultHandler,
  pmsData,
}) => {
  const [openAddPmsReportModal, setOpenAddPmsReportModal] = useState(false);
  const [pms, setPMS] = useState();

  return (
    <Skeleton loading={false} active>
      <HomePageHeader>
        <Col xxl={18} xl={18} lg={18} md={18} sm={24} xs={24}>
          <Form layout="vertical">
            <HeaderLeftItemsWrapper>
              <Col xxl={4} xl={4} lg={6} md={8} sm={24} xs={24}>
                <Form.Item label="PMS">
                  <PMSSelect value={pms} onChange={setPMS} />
                </Form.Item>
              </Col>
              <Col
                xxl={2}
                xl={2}
                lg={4}
                md={6}
                sm={24}
                xs={24}
                style={{ marginTop: "auto" }}
              >
                <Form.Item>
                  <Button
                    block
                    type="primary"
                    disabled={!pms}
                    loading={reportLoading}
                    style={{ maxWidth: "100px" }}
                    onClick={() => getPMSReportData(pms)}
                  >
                    Go
                  </Button>
                </Form.Item>
              </Col>
            </HeaderLeftItemsWrapper>
          </Form>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          <HeaderRightItemsWrapper>
            <HeaderRightItem>
              <div
                className="container_style_1_b"
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {pmsData?.length > 0 ? (
                  <BulkPMSReportCreation
                    dromoResultHandler={dromoResultHandler}
                    pmsData={pmsData}
                  />
                ) : (
                  ""
                )}

                <Tooltip placement="bottomRight" title="Add PMS Report">
                  <Button
                    onClick={() => setOpenAddPmsReportModal(true)}
                    type="link"
                    size="large"
                    icon={<PlusOutlined />}
                  >
                    Report
                  </Button>
                </Tooltip>
              </div>
            </HeaderRightItem>
          </HeaderRightItemsWrapper>
        </Col>
      </HomePageHeader>
      <AddPMSReport
        open={openAddPmsReportModal}
        setOpen={setOpenAddPmsReportModal}
        refetchReports={refetchReports}
        isReportListVisible={!!pmsId}
      />
    </Skeleton>
  );
};

export default ViewReportListHeader;
